import { Header } from '@/components/Header/Header'
import { HomePage } from '@/pages/HomePage/HomePage'
import { Landing } from '@/pages/Landing/Landing'
import { PostsPage } from '@/pages/PostsPage/PostsPage'
import { useAuthState } from '@/state/auth'
import { useBranchesState } from '@/state/branches'
import { useCommitsState } from '@/state/commits'
import { useGeneratorState } from '@/state/generator'
import { usePostsState } from '@/state/posts'
import { usePresetsState } from '@/state/presets'
import { useProjectsState } from '@/state/projects'
import { useRepoListState } from '@/state/repoList'
import { useToneState } from '@/state/tones'
import { useUserState } from '@/state/user'
import type { FunctionalComponent } from 'preact'
import { ErrorBoundary, LocationProvider, Router } from 'preact-iso'
import { useEffect } from 'preact/hooks'
import styles from './index.module.scss'

export const App: FunctionalComponent = () => {
  const token = useAuthState(s => s.token)
  const loading = useAuthState(s => s.loading)
  const fetchUser = useUserState(s => s.fetch)
  const resetUser = useUserState(s => s.reset)
  const fetchRepos = useRepoListState(s => s.fetch)
  const resetRepos = useRepoListState(s => s.reset)
  const fetchProjects = useProjectsState(s => s.fetch)
  const resetProjects = useProjectsState(s => s.reset)
  const fetchPresets = usePresetsState(s => s.fetch)
  const fetchPosts = usePostsState(s => s.fetch)
  const resetPosts = usePostsState(s => s.reset)
  const resetCommits = useCommitsState(s => s.reset)
  const resetGenerator = useGeneratorState(s => s.reset)
  const initBranchesState = useBranchesState(s => s.init)
  const resetBranchesState = useBranchesState(s => s.reset)
  const fetchToneState = useToneState(s => s.fetch)
  const resetToneState = useToneState(s => s.reset)

  useEffect(() => {
    if (token) {
      fetchUser()
      fetchRepos()
      fetchProjects()
      fetchPresets()
      fetchPosts()
      fetchToneState()
      initBranchesState()
    }
    else {
      resetUser()
      resetRepos()
      resetProjects()
      resetCommits()
      resetGenerator()
      resetPosts()
      resetBranchesState()
      resetToneState()
    }
  }, [token])

  if (loading) {
    return null
  }

  return (
    <LocationProvider>
      <ErrorBoundary>
        {token
          ? (
            <div class={styles.root}>
              <Header />
              <Router>
                <HomePage path='/' />
                <PostsPage path='/posts' />
              </Router>
            </div>
          )
          : <Landing />}
      </ErrorBoundary>
    </LocationProvider>
  )
}
